import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface KpiItem {
  label: string;
  value: string | number;
  hint?: string;
  tone?: "default" | "positive" | "warning" | "danger";
}

const TONE_CLASS: Record<NonNullable<KpiItem["tone"]>, string> = {
  default: "text-gray-900",
  positive: "text-green-600",
  warning: "text-amber-600",
  danger: "text-red-600",
};

export function KpiCards({ items }: { items: KpiItem[] }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {items.map((item) => (
        <Card key={item.label}>
          <CardContent className="p-4">
            <p className="text-xs font-medium text-gray-500">{item.label}</p>
            <p
              className={cn(
                "mt-1 text-xl font-bold",
                TONE_CLASS[item.tone ?? "default"],
              )}
            >
              {item.value}
            </p>
            {item.hint && (
              <p className="mt-0.5 text-[11px] text-gray-400">{item.hint}</p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export default KpiCards;
